import fetchApi from "../util/fetchApi";
import checkErrors from './checkErrors';


export const WorkflowApi = {
  
    async list({ offset, size, sortBy }) {
        return checkErrors(await fetchApi.api.get('manage/workflows', { query: { offset, size, sortBy } }));
    },

    async get({ workflowId }) {
        return checkErrors(await fetchApi.api.get(`manage/workflows/${workflowId}`));
    },

    async update(workflowId, workflow) {
         return checkErrors(await fetchApi.api.put(`manage/workflows/${workflowId}`,{data: workflow}));
    },

    async create(workflow) {
        return checkErrors(await fetchApi.api.post(`manage/workflows/`,{ data: workflow }));
   },

}

export default WorkflowApi;
